<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../Nav";
import Container from "./LicencaPrevidenciariaContainerCadastro"
export default {
  name: "LicencaPrevidenciariaCadastro",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaCadastro.vue